export default __webpack_public_path__ + "img/91497f8df2993d946070d7bc2f496ab6.png";